import Headroom from 'headroom.js'
import { getParent } from '../misc/Utils'

export default class SiteHeader {
    constructor() {
        this.cacheDom()
        this.bindEvents()
        this.initialize()
    }

    cacheDom() {
        this.body = document.body
        this.blackout = document.querySelector('.site-overlay')
        this.header = document.querySelector('.site-header')
        this.searchTrigger = document.querySelector('.search-trigger')
        this.menuTrigger = document.querySelector('.menu-trigger')
        this.shopTrigger = document.querySelector('.shop-menu-trigger')
        this.searchDropdown = document.querySelector('.user-menu-dropdown')
        this.shopDropdown = document.querySelector('.shop-menu-dropdown')
        this.children = document.querySelectorAll('.has-children')
        this.dropdown = document.querySelectorAll('.item-has-children .dropdown')

        /* Mobile navigation */
        this.mobileNavigation = document.querySelector('.mobile-navigation')
        this.mobileSearchTrigger = document.querySelector('.mobile-search-trigger')
        this.mobileLevelOneItems = document.querySelectorAll('.mobile-level-one-children')
        this.mobileLevelTwoItems = document.querySelectorAll('.mobile-level-two-children')
        this.backTriggers = document.querySelectorAll('.mobile-level-one-navigation__back button')
        this.mobileLevelTwoNavigation = document.querySelectorAll('.mobile-level-two-navigation')
    }

    bindEvents() {
        this.shopTrigger.addEventListener('click', this.toggleShop.bind(this))
        this.shopDropdown.addEventListener('mouseleave', this.closeShop.bind(this))
        this.menuTrigger.addEventListener('click', this.handleMobileMenu.bind(this))
        this.searchTrigger.addEventListener('click', this.toggleSearch.bind(this))

        this.mobileSearchTrigger.addEventListener('click', (event) => {
            this.searchTrigger.click()
        })

        Array.prototype.forEach.call(this.children, (child) => {
            child.addEventListener('click', this.handleChildren.bind(this))
        })

        Array.prototype.forEach.call(this.dropdown, (dropdown) => {
            dropdown.addEventListener('mouseleave', this.closeChildren.bind(this))
        })
        
        Array.prototype.forEach.call(this.mobileLevelOneItems, (element) => {
            element.addEventListener('click', this.handleMobileLevelOneItems.bind(this))
        })
        
        Array.prototype.forEach.call(this.backTriggers, (element) => {
            element.addEventListener('click', this.handleBackTriggers.bind(this))
        })
        
        Array.prototype.forEach.call(this.mobileLevelTwoItems, (element) => {
            element.addEventListener('click', this.handleMobileLevelTwoItems.bind(this))
        })
        
        this.searchDropdown.addEventListener('mouseleave', this.toggleSearch.bind(this))
    }

    initialize() {
        const headroom = new Headroom(this.header, {})
        headroom.init()
    }

    handleChildren(event) {
        event.preventDefault()
        const parent = event.target.parentNode

        if (parent.classList.contains('is-active')) {
            this.reset()
            return
        }

        this.reset()

        setTimeout(() => {
            parent.classList.toggle('is-active')
            this.header.classList.toggle('is-inverse')
            this.blackout.classList.toggle('is-visible')
            this.body.classList.toggle('overflow-hidden')
        }, 200)
    }

    closeChildren() {
        this.header.classList.remove('is-inverse')
        this.blackout.classList.remove('is-visible')
        this.body.classList.remove('overflow-hidden')

        Array.prototype.forEach.call(this.children, (child) => {
            child.parentNode.classList.remove('is-active')
        })
    }

    toggleSearch(event) {
        event.preventDefault()

        if (this.searchDropdown.classList.contains('is-active')) {
            this.reset()
            return
        }

        this.reset()

        setTimeout(() => {
            this.header.classList.toggle('is-inverse')
            this.blackout.classList.toggle('is-visible')
            this.body.classList.toggle('overflow-hidden')
            this.searchDropdown.classList.toggle('is-active')
        }, 200)
    }

    toggleShop(event) {
        event.preventDefault()
        const parent = event.target.parentNode

        if (parent.classList.contains('is-active')) {
            this.reset()
            return
        }

        this.reset()

        setTimeout(() => {
            parent.classList.toggle('is-active')

            this.header.classList.toggle('is-inverse')
            this.blackout.classList.toggle('is-visible')
            this.body.classList.toggle('overflow-hidden')
            this.shopDropdown.classList.toggle('is-active')
        }, 200)
    }

    closeShop() {
        this.shopTrigger.parentNode.classList.remove('is-active')
        this.header.classList.remove('is-inverse')
        this.blackout.classList.remove('is-visible')
        this.body.classList.remove('overflow-hidden')
        this.shopDropdown.classList.remove('is-active')
    }

    handleMobileMenu(event) {
        event.target.classList.toggle('is-open')
        this.header.classList.toggle('is-inverse')
        this.body.classList.toggle('overflow-hidden')

        if (this.mobileNavigation.classList.contains('is-open')) {
            this.closeMobileNavigation()
        }

        this.mobileNavigation.classList.toggle('is-open')
    }

    handleMobileLevelOneItems(event) {
        event.preventDefault()
        const parent = event.target.parentNode
        event.target.nextElementSibling.classList.toggle('is-open')
    }

    handleMobileLevelTwoItems(event) {
        event.preventDefault()
        const target = event.target
        const panel = event.target.nextElementSibling

        if (target.classList.contains('is-open')) {
            panel.style.maxHeight = 0
            target.classList.remove('is-open')
        } else {
            panel.style.maxHeight = panel.scrollHeight + 'px'
            target.classList.add('is-open')
        }
    }

    handleBackTriggers(event) {
        const parent = getParent(event.target, 4)
        parent.classList.remove('is-open')
    }

    closeMobileNavigation() {
        Array.prototype.forEach.call(this.mobileLevelTwoNavigation, (element) => {
            element.style.maxHeight = 0
            const backTrigger = element.previousElementSibling.classList.remove('is-open')
        })

        Array.prototype.forEach.call(this.backTriggers, (element) => {
            const parent = getParent(element, 4)
            parent.classList.remove('is-open')
        })
    }

    reset() {
        const items = document.querySelectorAll('.site-header .is-active')

        Array.prototype.forEach.call(items, (item) => {
            item.classList.remove('is-active')
        })

        this.body.classList.remove('overflow-hidden')
        this.header.classList.remove('is-inverse')
        this.blackout.classList.remove('is-visible')
    }
}
